import { throttle } from '../../../common/utils';

import els from './elements';

let context = null;

const shrinkWrap = () => {

    const $headline = els.$headline();

    const isWrapping = (
        $headline.height() > parseFloat($headline.css('line-height'))
    );

    gsap.set(
        $headline,
        { marginBottom: isWrapping ? '1rem' : '' }
    );

    if (isWrapping) {
        $headline.shrinkWrap();
    }
};

const prepare = () => {

    context = gsap.context(() => {

        shrinkWrap();

        const $headline = els.$headline();

        gsap.fromTo(
            $headline,
            {
                autoAlpha: 0,
                xPercent: -10,
            },
            {
                xPercent: 0,
                autoAlpha: 1,
                duration: 0.75,
                scrollTrigger: {
                    trigger: $headline,
                    start: 'top 80%',
                },
            }
        )
    });
};

const cleanUp = () => {

    const $headline = els.$headline();

    $headline.unshrinkWrap();

    gsap.set(
        $headline,
        { clearProps: 'marginBottom' }
    );

    context?.revert();
};

const initialize = () => {

    prepare();

    $(window).on(
        'resize:horizontally',
        throttle(
            () => {
                cleanUp();
                prepare();
            },
            100
        )
    )
};

export default {
    initialize,
};

